module.exports = __webpack_public_path__ + "./docs/img/big-icon-enum.60fb10071de66731ede1ff7d9a8f4e56.svg";